import { Template } from 'types';
import fetchWithRetry from './fetch-retry';

export const getTemplates = async ({ locationId }: { locationId?: string }): Promise<Template[]> => {
  // console.log(locationId, customerId);
  const url = new URL('/api/booking-templates', window.location.origin);
  if (locationId) url.searchParams.append('locationId', locationId);

  return await fetchWithRetry<Template[]>(url, { method: 'GET' }, []);
};

export const postTemplate = async (template: Template): Promise<void> => {
  const init: RequestInit = {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(template)
  };
  await fetchWithRetry('/api/booking-templates', init, null);
};
